export let HOME
export let WEIGHTS
export let DETAILS
export let GLYPHSET
export let ALTERNATES
export let STORY
export let SPECIMENS
export let BUY

WEIGHTS = {
  name: 'weights',
  title: 'Weights & Sizes',
  content: {
    images: [
      'images/weights-01.svg',
      'images/weights-02.svg',
      'images/weights-03.svg',
      'images/weights-04.svg',
      'images/weights-05.svg',
      'images/weights-06.svg',
      'images/weights-07.svg',
    ],
    labels: [
      {
        name: 'Victoria Hotel',
        path: 'images/labels/Arteria_etiquettes_hotel-alicante.png',
      },
      {
        name: 'Ditta Alfonso Evangelisti',
        path: 'images/labels/Arteria_fili-shop-signs-alfonso.png',
      },
    ],
  },
}

DETAILS = {
  name: 'principles',
  title: 'Principles',
  content: {
    drawing: {
      image: 'images/details-01.svg',
      image_hover: 'images/details_hover-01.svg',
    },
    comparison: {
      image: 'images/details_hover-02.svg',
      image_hover: 'images/details-02.svg',
    },
    alignments: [
      {
        image: 'images/details-03.svg',
      },
      {
        image: 'images/details-04.svg',
      },
      {
        image: 'images/details-05.svg',
      },
    ],
    labels: [
      {
        name: 'Grand Hotel Univers',
        path: 'images/labels/Arteria_etiquettes_hotel-univers.png',
      },
      {
        name: 'Panafico',
        path: 'images/labels/Arteria_fili-shop-signs-panafico.png',
      },
      {
        name: 'Grand Hotel des Palmes',
        path: 'images/labels/Arteria_etiquettes_hotel-palmes.png',
      },
    ],
  },
}

GLYPHSET = {
  name: 'alphabet',
  title: 'Alphabet',
  content: {
    glyphset: [
      'images/glyphset-01.svg',
      'images/glyphset-02.svg',
      'images/glyphset-03.svg',
      'images/glyphset-04.svg',
      'images/glyphset-05.svg',
      'images/glyphset-06.svg',
    ],
    glyphset_mobile: [
      'images/glyphset-mobile-01.svg',
      'images/glyphset-mobile-02.svg',
      'images/glyphset-mobile-03.svg',
      'images/glyphset-mobile-04.svg',
      'images/glyphset-mobile-05.svg',
      'images/glyphset-mobile-06.svg',
      'images/glyphset-mobile-07.svg',
      'images/glyphset-mobile-08.svg',
      'images/glyphset-mobile-09.svg',
    ],
    arrow: 'images/Alts-arrow.svg',
    lines: [
      ['images/Alts-01-1.svg', 'images/Alts-01-2.svg', 'images/Alts-01-3.svg'],
      ['images/Alts-02-1.svg', 'images/Alts-02-2.svg', 'images/Alts-02-3.svg'],
      ['images/Alts-03-1.svg', 'images/Alts-03-2.svg', 'images/Alts-03-3.svg'],
      ['images/Alts-04-1.svg', 'images/Alts-04-2.svg', 'images/Alts-04-3.svg'],
    ],
    labels: [
      {
        name: 'Hotel Livingstone',
        path: 'images/labels/Arteria_etiquettes_hotel-livingstone.png',
      },
      {
        name: 'Hotel Princesse',
        path: 'images/labels/Arteria_etiquettes_hotel-princesse.png',
      },
      {
        name: 'Macelleria con Vendita',
        path: 'images/labels/Arteria_fili-shop-signs-macelleria.png',
      },
      {
        name: 'Guglielmina Grand Hotel',
        path: 'images/labels/Arteria_etiquettes_hotel-guglielmina.png',
      },
    ],
  },
}

ALTERNATES = {
  name: 'try',
  title: 'Try yourself',
  content: {
    tester:
      'Arteria is a Compressed Display Typeface Available in Nine Weights. The Family Features not only Joyful Alternates, Small Caps, various Dingbats, Arrows, Quotes, different sets of Numerals but also Short Caps!',
    labels: [
      {
        name: 'Dirigente Movimento',
        path: 'images/labels/Arteria_fili-shop-signs-dirigente.png',
      },
    ],
  },
}

STORY = {
  name: 'story',
  title: 'Story',
  content: {},
}

SPECIMENS = {
  name: 'specimens',
  title: 'Foundry type specimens',
  content: {
    images: [
      {
        name: 'LT01',
        path: 'images/specimens/Arteria_Livret-Typographique_01.png',
      },
      {
        name: 'LT02',
        path: 'images/specimens/Arteria_Livret-Typographique_02.png',
      },
      {
        name: 'LT03',
        path: 'images/specimens/Arteria_Livret-Typographique_03.png',
      },
      { name: 'ATF', path: 'images/specimens/Arteria-ATF-1923.png' },
      {
        name: 'FTF',
        path:
          'images/specimens/Arteria-Fonderie-Typographique-Francaise_01.png',
      },
      { name: 'Nebiolo', path: 'images/specimens/Arteria-Nebolio_01.png' },
      {
        name: 'SB01',
        path: 'images/specimens/Arteria-Stephenson-Black_01.png',
      },
      {
        name: 'SB02',
        path: 'images/specimens/Arteria-Stephenson-Black_02.png',
      },
      {
        name: 'SB03',
        path: 'images/specimens/Arteria-Stephenson-Black_03.png',
      },
      {
        name: 'SB04',
        path: 'images/specimens/Arteria-Stephenson-Black_04.png',
      },
      {
        name: 'SB05',
        path: 'images/specimens/Arteria-Stephenson-Black_05.png',
      },
      {
        name: 'SB06',
        path: 'images/specimens/Arteria-Stephenson-Black_06.png',
      },
      {
        name: 'SB07',
        path: 'images/specimens/Arteria-Stephenson-Black_07.png',
      },
      {
        name: 'SB08',
        path: 'images/specimens/Arteria-Stephenson-Black_08.png',
      },
      {
        name: 'SB09',
        path: 'images/specimens/Arteria-Stephenson-Black_09.png',
      },
    ],
  },
}

BUY = {
  name: 'buy',
  title: 'A compressed display typeface in 9 weights.',
  content: {
    item_list: [
      {
        name: 'Download the pdf specimen',
        path:
          'https://typofonderie.com/specimen-download/arteria-compress-family',
      },
      {
        name: 'Buy Arteria at Typofonderie',
        path: 'https://typofonderie.com/fonts/arteria-compress-family/',
      },
      {
        name: 'Download the free Try-out fonts',
        path: 'https://typofonderie.com/fonts/arteria-compress-family/',
      },
    ],
  },
}

HOME = {
  name: 'home',
  title:
    'A compressed display typeface inspired by Italian shop signs & woodtype tradition.',
  fullscreen: true,
  content: {
    item_list: [WEIGHTS, DETAILS, GLYPHSET, ALTERNATES, STORY, SPECIMENS],
    labels: [
      {
        name: 'Berlin Hilton',
        path: 'images/labels/Arteria_etiquettes_hotel-berlin.png',
      },
      {
        name: 'Saturnia Hotel',
        path: 'images/labels/Arteria_etiquettes_hotel-saturnia.png',
      },
      {
        name: 'Capo Ufficio Veicoli',
        path: 'images/labels/Arteria_fili-shop-signs-ufficio.png',
      },
      {
        name: 'Hotel Isotta',
        path: 'images/labels/Arteria_etiquettes_hotel-isotta.png',
      },
      {
        name: 'Olio di Semi',
        path: 'images/labels/Arteria_fili-shop-signs-olio-semi.png',
      },
    ],
  },
}
